export const reason = [
  {
    id: 1,
    reason: "I am changing my device"
  },
  {
    id: 2,
    reason: "I am changing my phone number"
  },
  {
    id: 3,
    reason: "EN Connect is missing a feature"
  },
  {
    id: 4,
    reason: "EN Connect is not working"
  },
  {
    id: 5,
    reason: "Other"
  }
];
